import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setNumberContact,getFavoriteContacts, addContactToFavorites, deleteContactFromFavorites, getRecentContacts, addContactToRecents, setContactInfo} from '../../store/actions';
import { selectPaymentServiceContacts, selectContactNumberData } from '../../store/selectors/paymentsSelectors'
import styled from 'styled-components';
import ClaroList from '../organisms/ClaroList'
import ModalCardLoader from '../molecules/ModalCardLoader'
const Container = styled.div`
  width: 100%;
  height:100%;
  background: #fff;
`;

class ContactsContainer extends Component {

    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() { 
        this.props.getFavoriteContacts(this.props.serviceId);
        this.props.getRecentContacts(this.props.serviceId);
    }

    handleAddContactToFavorites = (contact, serviceId) => {
        this.props.addContactToFavorites(contact, serviceId)
    }
    
    handleDeleteContactFromFavorites = (contact, serviceId) => {
        this.props.deleteContactFromFavorites(contact, serviceId);
    }

    updateForm = (data) => {
      var number = null;
      let str = data.telephoneNumber.match(/\d/g).join("")
      number = str.substring(str.length - 10, str.length)
      this.props.setNumberContact(number)
      this.props.setContactInfo(data)
      window.history.back();
    }

    render() {
        if(Object.keys(this.props.contactsList).length !== 0 ) {
          if(this.props.contactsList.error && window.backContacts == true){
            window.history.back()
          } else {
            return ( 
              <ClaroList
                  serviceId={this.props.serviceId}
                  contactsList={this.props.contactsList}
                  favoriteContacts={this.props.favoriteContacts}
                  recentContacts={this.props.recentContacts}
                  title="Contactos"
                  changeDisplay={this.changeDisplay}
                  updateForm={this.updateForm}
                  handleAddContactToFavorites={this.handleAddContactToFavorites}
                  handleDeleteContactFromFavorites={this.handleDeleteContactFromFavorites}
              />
            )
          }
        }
        return (<ModalCardLoader
          isOpen={this.props.isLoading || this.props.isLoadingGetRecentContacts}
        />)
    }
}

function mapStateToProps(state) {
  const { payments } = state;
    const contactsList = selectPaymentServiceContacts(payments)
    const contactNumber = selectContactNumberData(payments)
  return {
    contactsList,
    contactNumber,
    favoriteContacts: state.payments.favoriteContacts,
    recentContacts: state.payments.recentContacts,
    isLoading: state.payments.isLoading,
    isLoadingGetRecentContacts: state.payments.isLoadingGetRecentContacts
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
        setNumberContact,
        getFavoriteContacts,
        addContactToFavorites,
        deleteContactFromFavorites,
        getRecentContacts,
        addContactToRecents,
        setContactInfo
    },
    dispatch,
  );
}

ContactsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactsContainer);

export default ContactsContainer